import axios from 'axios';
import { backendHOST } from '../client-config/client-config';
import setAuthToken from '../utils/setAuthToken';

const url = `${backendHOST}/api/taskManager`;

function ensureAuthToken() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
    return true;
  }

  return false;
}

export async function getUserTasks() {
  if (!ensureAuthToken()) return [];

  try {
    const res = await axios.get(`${url}/UserTasks`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    console.error('Feladatok betöltési hiba:', error);
    return [];
  }
}
